/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, TextField } from "@mui/material";
import { QueryDocumentSnapshot, collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";

type OptionProps = {
  masterName: string
  valueKey: string
  labelKey: string
}
type Props = {
  name: string,
  value: any,
  onChange: any,
  optionProps: OptionProps,
  text?: string
  disabled?: boolean,
  label?: string
}

export const MasterSelect = (props: Props) => {
  const { name, value, optionProps, text, disabled, onChange, label } = props
  const [selectItems, setSelectItems] = useState<Array<any>>([])

  useEffect(() => {
    const q = query(collection(db, optionProps.masterName), where("status", "==", "active"))
    const unsubscribe = onSnapshot(q, ({ docs }) => {
      setSelectItems(docs.map((_: QueryDocumentSnapshot) => {
        const data = { ..._.data(), id: _.id }
        return ({ value: data[optionProps.valueKey], label: data[optionProps.labelKey] })
      }))
    })
    return unsubscribe
  }, [])

  return (
    <Autocomplete
      id={name}
      blurOnSelect={true}
      value={value}
      options={selectItems}
      sx={{ width: 200 }}
      renderInput={(params) => <TextField {...params} name={name} label={label || text} />}
      onChange={(_e: React.SyntheticEvent, values: any) => onChange({ label: values.label, value: values.value })}
      disabled={disabled}
    />
  )
}
